export default "__VITE_ASSET__D7_3Zbxn__"